const RequestRubleSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="none"><circle cx="13.5" cy="13.5" r="13.5" fill="#B6BFE7"/><path fill="#fff" d="M14.235 16.355h-1.86v.825h3.345v1.32h-3.345V20H10.32v-1.5H9.195v-1.32h1.125v-.825H9.195V14.54h1.125V9.5h3.915c.99 0 1.825.34 2.505 1.02.69.68 1.035 1.5 1.035 2.46s-.34 1.765-1.02 2.415c-.67.64-1.51.96-2.52.96Zm0-4.92h-1.86v3.105h1.86c.42 0 .77-.15 1.05-.45.29-.3.435-.67.435-1.11 0-.44-.145-.805-.435-1.095-.28-.3-.63-.45-1.05-.45Z"/></svg>
    )
}

export default RequestRubleSvg;